import React from 'react';
import { Loading } from '@ss/mtd-react';

interface Props {
  requestCode: string;
  // eslint-disable-next-line react/no-unused-prop-types
  onSuccess?: () => void;
}
interface State {
  loading: boolean;
}
class Yoda extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  options: any;

  componentDidMount() {
    const { requestCode } = this.props;
    this.options = {
      requestCode, // 必须 授权码
      succCallbackFun: 'yodaSliderSuccess', // 必须 成功回调函数名
      failCallbackFun: 'yodaSliderFailure', // 必须 失败回调函数名
      root: 'slider', // 必须 挂载业务方页面节点id
      theme: 'meituan', // 必须 主题 默认‘meituan’
      mounted: () => {
        this.setState({ loading: false });
      },
      style: { wrapper: 'wrapper', sliderTtile: 'title' },
    };
    // Yoda支持的环境参数 dev|test|ppe|staging
    switch (process.env.BLOCK_ENV) {
      case 'production': // Yoda线上环境
        YodaSeed(this.options);
        break;
      case 'staging':
        YodaSeed(this.options, 'staging');
        break;
      case 'test':
        YodaSeed(this.options, 'test');
        break;
      default:
        YodaSeed(this.options, 'test');
    }
  }

  render() {
    const { loading } = this.state;
    return (
      <div>
        <div className="loading">{loading && <Loading />}</div>
        <div id="slider" className="yoda-slider" />
      </div>
    );
  }
}

export default Yoda;
